import React from 'react';

export default function InfoRow({
  label,
  showEdit = true,
  value = '-',
  noBorder = false,
  t,
  onEdit,
}) {
  return (
    <div
      className="info-row-wrapper"
      style={{ borderBottom: noBorder ? 'none' : '1px solid rgba(0, 0, 0, 0.09)' }}
    >
      <div className="row-label">
        <span className="label">{label}</span>
        {showEdit && (
          <span onClick={onEdit} className="edit">
            {t('cms:cms.tag.column.actions.edit')}
          </span>
        )}
      </div>
      <span className="value">{value}</span>
    </div>
  );
}
